import React from 'react'
import { selectPhone, selectIsSpecialPhoneNumber } from './contactInfo.selectors'
import { useSelector } from 'react-redux'
import s from './GeoentityPhoneModalContent.less'
import RectangleActionButton, {
  COLOR_GREEN,
  COLOR_GREY_EMPTY
} from '../../genericComponents/buttons/RectangleActionButton'
import SpecialPhoneNumberCartridge from '../../genericComponents/SpecialPhoneNumberCartridge'
import SimplePhoneCartridge from '../../genericComponents/SimplePhoneCartridge'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import useCommonGeoentityClickTagProps from '../useCommonGeoentityClickTagProps'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { useAction } from '../../utils/react-redux'
import { navigateBack } from '../../../store/history/history.actions'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import { SPD_GEOENTITY_PHONE } from '../../analytics/BiTagger'

export default withEmptyFallbackErrorBoundary(function GeoentityPhoneModalContent() {
  const execNavigateBack = useAction(navigateBack)
  const sendBiTagCall = useTagBiForGeoentity(SPD_GEOENTITY_PHONE)
  const { number } = useSelector(selectPhone)
  const clickTagProps = useCommonGeoentityClickTagProps(PUB_TAG.PUB_FICHEPOI_CALL)

  return (
    <div>
      <div className={s.titleContainer}>Téléphone</div>
      <div className={s.phoneContainer}>
        <PhoneDisplayer />
      </div>
      <div className={s.buttonsContainer}>
        <RectangleActionButton color={COLOR_GREY_EMPTY} label="Annuler" onClick={() => execNavigateBack()} />
        <RectangleActionButton
          color={COLOR_GREEN}
          label="Appeler"
          tagData={clickTagProps}
          deferClick
          onClick={() => {
            sendBiTagCall()
            window.open(`tel:${number}`)
          }}
        />
      </div>
    </div>
  )
})

function PhoneDisplayer() {
  const isSpecialNumber = useSelector(selectIsSpecialPhoneNumber)
  const { number, category, text } = useSelector(selectPhone)

  return !isSpecialNumber ? (
    <SimplePhoneCartridge {...{ number }} />
  ) : (
    <SpecialPhoneNumberCartridge {...{ number, text, category }} />
  )
}
